
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, HostListener, Injector, Input, OnInit, ViewChild, WritableSignal, computed, effect, model, runInInjectionContext, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { interval } from 'rxjs';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzCardComponent } from 'ng-zorro-antd/card';
import { NzSpinComponent } from 'ng-zorro-antd/spin';
import { NzEmptyComponent } from 'ng-zorro-antd/empty';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzStatisticComponent } from 'ng-zorro-antd/statistic';
import { FikoYTKartComponent } from '../../../../fikoyt-kart/fikoyt-kart.component';
import { ParametrelerComponent } from '../../../../parametreler/parametreler.component';
import { FikoYTKokBilesenComponent } from '@/src/service/kok-bilesen/kok-bilesen.component';
import { ServisUyarService } from '@/src/app/uygulamalar/uyar-dokum/servis-uyar.service';
import { IParametre } from '@/src/service/fikoyt-ui/interfaces/IParametre/IParametre';
import { FikoYTId } from '@/src/service/fikoyt-ui/helpers/FikoYTId';
import { FikoYTIstekKok } from '@/src/service/modules/fikoyt-istek-kok/fikoyt.istek.makinesi.service';
import { NzButtonComponent } from 'ng-zorro-antd/button';
import { NzWaveModule } from 'ng-zorro-antd/core/wave';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { IKart, IKartTuru } from '@/src/service/fikoyt-ui/interfaces/IKart.interface';
import { NzPopconfirmComponent, NzPopconfirmModule, NzPopconfirmDirective } from 'ng-zorro-antd/popconfirm';


@Component({
  selector: 'fikoyt-uyar-firma-ekle',
  templateUrl: './.component.html',
  styleUrls: ['./.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    FormsModule,
    RouterModule,
    NzLayoutModule,
    NzGridModule,
    ParametrelerComponent,
    NzButtonComponent,
    NzWaveModule,
    NzIconModule,
    NzPopconfirmModule
  ]
})
export class FirmaEkleComponent extends FikoYTKokBilesenComponent {
  @ViewChild('parametrelerBilesen') paramComponent!: ParametrelerComponent;
  @ViewChild('gonderButton', { read: ElementRef }) gonderButton?: ElementRef;
  /** */
  ekleIstek: FikoYTIstekKok;
  kontrolIstek: FikoYTIstekKok;


  rota? = model("ana-sayfa");

  parametreler: IParametre[] = [
    {
      turu: "Resim",
      ismi: "logo",
      baslik: "Firma Logosu",
      altAciklama: "Firmanın Logosunu Giriniz Yada Anımsatacak Bişiler.\nselanar",
      degeri: null,
      yerTutucu: "Firma Logosu",
      ayarlar: {},
      kontroller: [
        {
          fn: `
            let dgr = itm.degeri;
            /** BİLGİ:  Eğer Türü String İse Ve Bişi Girilmemişse */
            if (dgr === '' || dgr === null) { 
              itm.uyarilar.push({
                renk: "blue",
                mesaj: "Logo Alanı Eklemeniz Firmaları Daha Kolay Ayırt Etmenizi Sağlar."
              });  
            }
            /** NOT:  Tüm Testlerden Geçti */
            return true;
          `
        },
      ]
    }, 
    {
      turu: "Yazı",
      ismi: "ismi",
      altAciklama: "Firmanın İsmini Giriniz",
      yerTutucu: "Firma İsmi",
      baslik: "Firma İsmi",
      degeri: null,
      ayarlar: {
        solSimge: "🖋",
      },
      kontroller: [
        {
          fn: `
            let dgr = itm.degeri;
            /** BİLGİ:  Eğer Türü String İse Ve Bişi Girilmemişse */
            if (dgr === '' || dgr === null) { 
              itm.hatalar.push({
                renk: "red",
                mesaj: "Firma İsmi Gereklidir."
              }); 
            }
            /** NOT:  Tüm Testlerden Geçti */
            return true;
          `
        },
      ]
    }
    ,
    {
      turu: "Yazı Alanı",
      ismi: "aciklama",
      altAciklama: "Açıklama Giriniz",
      yerTutucu: "Açıklama",
      baslik: "Açıklama",
      degeri: null,

      ayarlar: {
        solSimge: "🖋",
      },
      kontroller: [
      ]
    },
  ];


  constructor(public servisUyar: ServisUyarService) {
    super();

    this.ekleIstek = new FikoYTIstekKok({
      metod: 'POST',
      komut: `FikoYT.sistem.DB.hareketler.ekle`,
      onEkOlsun: true,
      // parametreler: { id: 123 },
      depoModu: false,
      oncelik: 0,
      gecikmeliCevap: true,
      gecikmeliCevapSuresi: 500,

    }).onHata(({ self, hatalar }) => {
      this.nzNotification.error("Hatalar Var", hatalar.map(hata => hata.mesaj).join("\n"), { nzPlacement: 'bottomRight' });
    }).onTamamlandi(({ self }) => {
      this.CD.detectChanges();
    });
  }


  override ngOnDestroy() {
    super.ngOnDestroy();
  }


  override async ngAfterViewInit() {
    super.ngAfterViewInit();


  }


  // async formuGonder() {


  //   let kontrol = await this.paramComponent.tumHatalariniAl(this.paramComponent.parametreler)

  //   if (kontrol.hatalar.length > 0) {
  //     this.nzNotification.error("Hatalar Var", kontrol.hatalar.map(parametreler => parametreler.hatalar.map(hata => hata.mesaj).join("\n")).join("\n"), { nzPlacement: 'bottomRight' });
  //     return;
  //   }
  //   let json = this.paramComponent.toJson();
  //   /** */
  //   let istekKayitVarmi = new FikoYTIstekKok({
  //     metod: 'POST',
  //     komut: 'FikoYT.sistem.DB.hareketler.aggregate',
  //     gecikmeliCevap: false,
  //   })

  //   istekKayitVarmi.parametreler = {
  //     aggregate: [
  //       {
  //         $match: { "veri.ismi": json?.ismi, "vt": "FikoYT.Uyar.firmalar" },
  //       },
  //     ]
  //   };
  //   await istekKayitVarmi.isteSync();
  //   if (istekKayitVarmi.cevap.sonuc) {
  //     this.nzNotification.error("Hata", `${json?.ismi} adlı firma Zaten Mevcut.`, { nzPlacement: 'bottomRight' });
  //     this.paramComponent.parametreBul({ ismi: "ismi" }, { tamEslestir: false }).forEach(param => param.hatalar.push({ renk: "red", mesaj: `${json?.ismi} adlı firma Zaten Mevcut.` }));
  //     this.CD.detectChanges();
  //     return;
  //   }

  //   /** */
  //   let dosyalar = this.paramComponent.dosyalar();

  //   /** */
  //   if (kontrol.uyarilar.length > 0) {
  //     let uyarilar = kontrol.uyarilar.map(parametreler => parametreler.uyarilar.map(uyari => uyari.mesaj).join("\n")).join("\n");


  //     this.nzModalServis.confirm({
  //       nzTitle: 'Eminmisiniz?',
  //       nzBodyStyle: { whiteSpace: 'pre-wrap', },
  //       nzIconType: 'question-circle',
  //       nzContent: `${uyarilar}\nYukarıdaki Uyarılara Rağmen Devam Etmek İstiyormusunuz?`,
  //       nzOnOk: async () => {
  //         console.log(json);

  //         let kalem: IKart = {
  //           turu: IKartTuru.UYAR_DOKUM,
  //           vt: "FikoYT.Uyar.firmalar",
  //           yol: "FikoYT.Uyar.firmalar.kalem",
  //           sahip: this.FikoYT.kimlik.aktifKullaniciJson()._id,
  //           tarih: new Date(),
  //           parametreler: this.paramComponent.parametreler,
  //           uygulama: ["Uyar Döküm"],
  //           veri: json,
  //         }

  //         const formData = new FormData();
  //         formData.append("req_body", JSON.stringify(kalem));
  //         for (const d of dosyalar) {
  //           formData.append(d.id, d.dosya, d.dosya.name);
  //         }

  //         this.ekleIstek.parametreler = formData;

  //         let cevap: any = await this.ekleIstek.isteSync();

  //         if (cevap.cevap.sonuc) {
  //           this.nzNotification.success("Başarılı", `${json?.ismi} adlı firmanın kaydı eklendi`, { nzPlacement: 'bottomRight' });
  //         }
  //         else {
  //           this.nzNotification.error("Hata", `${json?.ismi} adlı firma eklenemedi`, { nzPlacement: 'bottomRight' });
  //         }
  //       },
  //       nzOnCancel: () => {

  //       }

  //     });

  //   } else {
  //     let kalem: IKart = {
  //       turu: IKartTuru.UYAR_DOKUM,
  //       vt: "FikoYT.Uyar.firmalar",
  //       yol: "FikoYT.Uyar.firmalar.kalem",
  //       sahip: this.FikoYT.kimlik.aktifKullaniciJson()._id,
  //       tarih: new Date(),
  //       parametreler: this.paramComponent.parametreler,
  //       uygulama: ["Uyar Döküm"],
  //       veri: json,
  //     }


  //     const formData = new FormData();
  //     formData.append("req_body", JSON.stringify(kalem));
  //     for (const d of dosyalar) {
  //       formData.append(d.id, d.dosya, d.dosya.name);
  //     }

  //     this.ekleIstek.parametreler = formData;

  //     let cevap: any = await this.ekleIstek.isteSync();

  //     if (cevap.cevap.sonuc) {
  //       this.nzNotification.success("Başarılı", `${json?.ismi} adlı firmanın kaydı güncellendi`, { nzPlacement: 'bottomRight' });
  //     }
  //     else {
  //       this.nzNotification.error("Hata", `${json?.ismi} adlı firma güncellenemedi`, { nzPlacement: 'bottomRight' });
  //     }
  //   }
  // }

  param(name: string) {
    return this.paramComponent.parametreler[name];
  }
}
